import { Component, ComponentFactoryResolver, ChangeDetectorRef, inject } from '@angular/core';
import { ListLayoutSingleComponent } from 'gung-list';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CartService } from '../../services/cart/cart.service';

@Component({
    selector: 'lib-cart-list-layout',
    templateUrl: './cart-list-layout.component.html',
    styleUrls: ['./cart-list-layout.component.css'],
    standalone: false
})
export class CartListLayoutComponent<T> extends ListLayoutSingleComponent<T> {
  private cartService = inject(CartService);
  private modalService = inject(NgbModal);

  public removeAll(content): void {
    this.modalService.open(content).result.then(
      closeResult => {
        if (closeResult === 'CLEAR_CART') {
          this.cartService.clearCart();
        }
      },
      dissmissReason => {
        console.log(dissmissReason);
      }
    );
  }
}
